import { render, staticRenderFns } from "./up_files.vue?vue&type=template&id=7889f44e&scoped=true"
import script from "./up_files.vue?vue&type=script&lang=js"
export * from "./up_files.vue?vue&type=script&lang=js"
import style0 from "./up_files.vue?vue&type=style&index=0&id=7889f44e&prod&scoped=true&lang=less"
import style1 from "./up_files.vue?vue&type=style&index=1&id=7889f44e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7889f44e",
  null
  
)

export default component.exports